import React, { FC } from 'react';
import styles from './notification_watcher_count.module.scss';

export const NotificationWatcherCount: FC = ({ children }) => (
  <span className={styles.container}>{children}</span>
);
